import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getVehiclesLocations } from '../../services/MapsService';
import { LocationVehiclesResponse } from '../../types/Maps';
import { FeaturesManagement } from '../../../featuresControl';

function useGetVehiclesLocations(fleetId: string, query?: string): UseQueryResult<LocationVehiclesResponse> {
  return useQuery(
    ['vehiclesLocations', fleetId, query],
    async (): Promise<LocationVehiclesResponse> => getVehiclesLocations(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
      keepPreviousData: true,
    },
  );
}

export default useGetVehiclesLocations;
